function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Iconly/Bulk/Profile"
}, /*#__PURE__*/React.createElement("g", {
  id: "Profile"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  d: "M11.9968 15.1748C7.68376 15.1748 3.99976 15.8548 3.99976 18.5748C3.99976 21.2958 7.66076 21.9998 11.9968 21.9998C16.3098 21.9998 19.9938 21.3208 19.9938 18.5998C19.9938 15.8788 16.3338 15.1748 11.9968 15.1748Z",
  fill: "#8B8B8B"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 4",
  opacity: 0.4,
  d: "M11.9968 12.584C14.9348 12.584 17.2888 10.229 17.2888 7.292C17.2888 4.355 14.9348 2 11.9968 2C9.05983 2 6.70483 4.355 6.70483 7.292C6.70483 10.229 9.05983 12.584 11.9968 12.584Z",
  fill: "#8B8B8B"
})));
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.66703328.svg";
export { ForwardRef as ReactComponent };